import { CloseCircleFilled } from '@ant-design/icons';
import { Card, theme } from 'antd';
import { useTranslation } from 'react-i18next';

export const InvalidBatchCard = () => {
	const { t } = useTranslation();
	const {
		token: { red5 },
	} = theme.useToken();

	return (
		<Card
			title={
				<div className="flex row items-center">
					<div className="pr-[8px]">
						<CloseCircleFilled style={{ fontSize: '16px', color: red5 }} />
					</div>
					<div className="pl-[8px]">{t('invalidBatch')}</div>
				</div>
			}
		>
			<p>{t('batchDoesNotExist')}</p>
		</Card>
	);
};
